import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, CalendarDays, HeartHandshake, HeartPulse, Sparkles, Crown } from "lucide-react";
import { isPlusUser } from "../lib/gentleflowPlus";

const SHOW_ROUTES = new Set([
  "/calendar", "/lifestyle", "/analytics", "/reminders", "/wellness",
  "/wellness-tips", "/tips", "/learn", "/community", "/symptom-analyzer",
  "/mood-coach", "/food-recommendations", "/workout-planner", "/rewards",
  "/achievements", "/profile", "/plus/features", "/plus/insights"
]);

const JOURNEY = [
  {path:"/calendar", tag:"01 · TRACK", title:"Listen to your body", description:"Record the things you want to remember.", Icon:CalendarDays},
  {path:"/bodyos", tag:"02 · UNDERSTAND", title:"Notice your patterns", description:"See what your own logs have to say.", Icon:Sparkles},
  {path:"/carepass", tag:"03 · BE PREPARED", title:"Keep care within reach", description:"Plan pads and find genuine care points.", Icon:HeartHandshake}
];

export default function ExperienceJourney({user}){
  const {pathname}=useLocation();
  if(!SHOW_ROUTES.has(pathname)) return null;
  const plus=isPlusUser(user);
  return <section className="gf-journey-ribbon" aria-label="Continue your Gentleflow journey">
    <header className="gf-journey-heading">
      <div><span><HeartPulse size={15}/> GENTLEFLOW · ALWAYS CONNECTED</span><h2>Your care doesn't stop here.</h2><p>One gentle journey, connected from your daily check-in to practical period care.</p></div>
      <Link to={plus?"/plus/insights":"/plus"} className="gf-journey-plus-link">{plus?"My Plus insights":"What Plus adds"} <Crown size={15}/></Link>
    </header>
    <div className="gf-journey-steps">
      {JOURNEY.map(({path,tag,title,description,Icon})=><Link to={path} key={path} className={pathname===path?"gf-journey-current":""}>
        <span className="gf-journey-step-icon"><Icon size={23} strokeWidth={1.65}/></span>
        <span className="gf-journey-step-copy"><small>{tag}</small><strong>{title}</strong><span>{description}</span></span>
        <ArrowRight className="gf-journey-arrow" size={17}/>
      </Link>)}
    </div>
    <div className="gf-journey-foot"><span>Tracking and CarePass supply planning are included in Normal. Advanced BodyOS tools require Plus.</span></div>
  </section>;
}
